import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './msalConfig';

// The one MSAL instance - this connects to your Azure AD app. In its own module so the shared axios
// instance can ask it for a fresh token (auth/accessToken.ts) without importing LoginButton, which
// imports that axios instance. LoginButton re-exports it, so existing imports keep working.
export const msalInstance = new PublicClientApplication(msalConfig);
